"use strict";
/**
 * Created on 05 17 2020
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var AppRecalcInitiation_1 = require("../AppRecalcInitiation");

var AppRecalcInitiationConverter_1 = require("./AppRecalcInitiationConverter");
/**
 * <p>Implementation of {@link AppRecalcInitiationConverter}.</p>
 *
 * @author JMe
 */


var AppRecalcInitiationConverterImpl =
/*#__PURE__*/
function (_AppRecalcInitiationC) {
  _inherits(AppRecalcInitiationConverterImpl, _AppRecalcInitiationC);

  function AppRecalcInitiationConverterImpl() {
    _classCallCheck(this, AppRecalcInitiationConverterImpl);

    return _possibleConstructorReturn(this, _getPrototypeOf(AppRecalcInitiationConverterImpl).apply(this, arguments));
  }

  _createClass(AppRecalcInitiationConverterImpl, [{
    key: "toDocument",

    /**
     * @inheritDoc
     */
    value: function toDocument(source, conversions) {
      if (typeof source !== 'object' || source === null) {
        return null;
      }

      var result = {};
      Object.assign(result, conversions.classToDocumentId(source));
      Object.assign(result, {
        initiated: conversions.fromDate(source.initiated)
      });
      return result;
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toObject",
    value: function toObject(source, conversions) {
      return new AppRecalcInitiation_1.AppRecalcInitiation(conversions.documentToClassId(source), conversions.asObject(source, 'initiated', function (v) {
        return conversions.toDate(v);
      }));
    }
  }]);

  return AppRecalcInitiationConverterImpl;
}(AppRecalcInitiationConverter_1.AppRecalcInitiationConverter);

exports.AppRecalcInitiationConverterImpl = AppRecalcInitiationConverterImpl;